module.exports = "img/3.34d98c.webp";